let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dqckE")).then(() => parcelRequire('8gvqu'));